(() => {
  let detailsTemplate;

  const openInbox = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return false;
    chat.setAttribute('open', '');
    return true;
  };

  const placeDetails = (root) => {
    const slot = root.querySelector('[data-lw-pdp-details-slot]');
    if (!slot) return;

    if (!detailsTemplate) {
      const sourceSection = document.querySelector('.shopify-section--lw-pdp-details');
      const source = sourceSection?.querySelector('.lw-pdp-details');
      if (!source) return;
      detailsTemplate = source.cloneNode(true);
      source.remove();
      sourceSection.hidden = true;
    }
    if (slot.querySelector('.lw-pdp-details')) return;

    const details = detailsTemplate.cloneNode(true);
    details.classList.remove('container');
    details.classList.add('lw-pdp-details--inline');
    slot.append(details);
  };

  const initialize = (root) => {
    if (root.dataset.lwInitialized === 'true') return;
    root.dataset.lwInitialized = 'true';

    const requiresSize = root.dataset.requiresSize === 'true';
    let sizeChosen = !requiresSize || new URLSearchParams(location.search).has('variant');
    if (requiresSize && !sizeChosen) {
      root.querySelectorAll('[data-lw-size-option] input[type="radio"]:checked').forEach((input) => {
        input.checked = false;
      });
    }

    const sync = () => {
      if (!requiresSize) return;
      root.classList.toggle('lw-has-size', sizeChosen);
      const selector = root.querySelector('[data-lw-size-option]');
      if (selector) {
        selector.classList.toggle('lw-size-unconfirmed', !sizeChosen);
        if (!sizeChosen) {
          selector.querySelectorAll('input[type="radio"]:checked').forEach((input) => { input.checked = false; });
          const value = selector.querySelector('.product-form__option-value, .select__selected-value');
          if (value) value.textContent = 'Select a size';
        }
      }

      root.querySelectorAll('[data-product-add-to-cart-button]').forEach((button) => {
        if (button.disabled) return;
        if (!button.dataset.lwOriginalContent) {
          button.dataset.lwOriginalContent = button.dataset.buttonContent || button.textContent.trim();
        }
        const content = sizeChosen ? button.dataset.lwOriginalContent : 'Select your size';
        button.dataset.buttonContent = content;
        const label = button.querySelector('.loader-button__text');
        if (label) label.textContent = content;
        else button.textContent = content;
        button.toggleAttribute('data-lw-needs-size', !sizeChosen);
        button.removeAttribute('aria-disabled');
      });
    };

    const focusSize = () => {
      const selector = root.querySelector('[data-lw-size-option]');
      if (!selector) return;
      const error = selector.querySelector('.lw-pdp__size-error');
      if (error) error.hidden = false;
      selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const control = selector.querySelector('input[type="radio"], button[aria-haspopup="listbox"], select');
      control?.focus({ preventScroll: true });
    };

    const clearSizeError = () => {
      const error = root.querySelector('[data-lw-size-option] .lw-pdp__size-error');
      if (error) error.hidden = true;
    };

    root.addEventListener('change', (event) => {
      if (!requiresSize) return;
      if (event.target.closest('[data-lw-size-option]')) {
        sizeChosen = true;
        clearSizeError();
        sync();
      }
    }, true);

    root.addEventListener('click', (event) => {
      const inboxLink = event.target.closest('[data-lw-inbox-trigger]');
      if (inboxLink) {
        if (openInbox()) event.preventDefault();
        return;
      }
      if (requiresSize && event.target.closest('[data-lw-size-option] label, [data-lw-size-option] input[type="radio"]')) {
        sizeChosen = true;
        clearSizeError();
        sync();
      }
      const button = event.target.closest('[data-product-add-to-cart-button]');
      if (!button || sizeChosen || button.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      focusSize();
    }, true);

    root.addEventListener('submit', (event) => {
      if (sizeChosen || event.target.id !== root.dataset.formId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      focusSize();
    }, true);

    root.addEventListener('product:rerender', () => requestAnimationFrame(() => requestAnimationFrame(() => {
      sync();
      placeDetails(root);
    })));
    root.addEventListener('variant:changed', () => requestAnimationFrame(sync));
    sync();
    placeDetails(root);
  };

  const start = () => document.querySelectorAll('[data-lw-pdp]').forEach((root) => {
    initialize(root);
    placeDetails(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('shopify-section--lw-pdp-details')) {
      detailsTemplate = undefined;
      document.querySelectorAll('[data-lw-pdp-details-slot] .lw-pdp-details').forEach((panel) => panel.remove());
    }
    start();
  });
})();
